import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import {
  DxiButtonComponent,
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import { firstValueFrom } from 'rxjs';
import { Articoli } from 'src/app/models/articoli';
import { KitArticoliService } from 'src/app/shared/services/kit-articoli.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';
import { DxDataGridComponent } from 'devextreme-angular';
import { KitArticoli } from 'src/app/models/kit-articolo';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-grid-kit-articoli',
  templateUrl: './grid-kit-articoli.component.html',
  styleUrls: ['./grid-kit-articoli.component.scss'],
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxoLookupComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoEditingComponent,
    DxoColumnChooserComponent,
    DxiButtonComponent,
    DxoTextsComponent,
    DxoExportComponent
  ],
})
export class GridKitArticoliComponent implements OnInit {
  private kitArticoliService = inject(KitArticoliService);
  private articoliService = inject(ArticoliService);

  @ViewChild('datagrid', { static: false })
  grid!: DxDataGridComponent;
  @Input() idArticolo: number = 0;

  dataSource: CustomStore = new CustomStore();
  listArticoli: Articoli[] = [];
  listArticoliKit: KitArticoli[] = [];

  ngOnInit() {
    this.loadDataSource();
    this.loadLookUp();
  }

  onRowUpdating(e: any) {
    const updatedProps = Object.assign(e.oldData.props, e.newData.props);
    e.newData = Object.assign(e.oldData, e.newData);
    e.newData.props = updatedProps;
  }

  loadLookUp() {
    this.articoliService.listNonKit().subscribe({
      next: (res) => {
        this.listArticoli = res.filter((x) => x.id != this.idArticolo); //Tolgo dalla lista l'articolo della pagina
      },
      error: (err) => {
        if (err?.error?.title) {
          notificaMessaggio(err.error.title, 'error');
        } else {
          notificaMessaggio('Errore lista degli articoli', 'error');
        }
      },
    });
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(
          this.kitArticoliService.listByIdArticolo(this.idArticolo),
        )
          .then((response) => {
            this.listArticoliKit = response;
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        if (!('idArticoloComponente' in values) || !('quantita' in values)) {
          return Promise.reject(
            'Inserire articolo componente e una quantità valida',
          );
        }

        if (!values.idArticoloComponente || values.quantita <= 0) {
          return Promise.reject(
            'Inserire articolo componente e una quantità valida',
          );
        }
        if(this.listArticoliKit.some(x => x.idArticoloComponente == values.idArticoloComponente)){
          return Promise.reject(
            'Componente già presente nel kit',
          );
        }
        values.idArticolo = this.idArticolo;
        return firstValueFrom(this.kitArticoliService.insert(values))
          .then((response) => {
            this.listArticoliKit.push(response);
            return response;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Inserimento fallito';
            }
          });
      },
      update: (key, values) => {
        let index = this.listArticoliKit.findIndex((x) => x.id == key);
        const updated = {
          ...this.listArticoliKit[index],
          ...values,
        };
        this.listArticoliKit[index] = updated;

        return firstValueFrom(this.kitArticoliService.update(key, updated))
          .then(() => {
            notificaMessaggio('Modifica avvenuta con successo', 'success');
          })
          .catch(() => {
            throw 'Update failed';
          });
      },
      remove: (key) => {
        return firstValueFrom(this.kitArticoliService.delete(key))
          .then(() => {
            notificaMessaggio('Cancellazione avvenuta con successo', 'success');
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Deletion failed';
            }
          });
      },
    });
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }
    return item.codice + ' - ' + item.descrizione;
  }

  onEditorPreparing(e: any) {
    if (
      e.parentType === 'dataRow' &&
      e.dataField === 'idArticoloComponente' &&
      !e.row?.isNewRow
    ) {
      e.editorOptions.disabled = true;
    }
  }

  onExporting(e: any){
    const art = this.listArticoli.find(x => x.id == this.idArticolo);
    const fileName = 'Kit_Articolo' + (art != undefined ? '_' + art.descrizione : '');
    GridExportExcel(e, 'Kit Articolo', fileName + '.xlsx');
  }
}
